import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/about/about_group.png")